import ym from 'react-yandex-metrika';

type EventName =
  | 'auth/complete'
  | 'auth/visit'
  | 'auth/callback-chrome'
  | 'auth/callback-windows'
  /**
   * This event is used to track `created` guides, not try to create.
   */
  | 'guides/create'
  | 'guides/create:try-manual'
  | 'guides/create:try-extension'
  | 'guides/create:try-windows'
  | 'guides/share-copy-link'
  | 'guides/export-copy-html'
  | 'guides/export-success'
  | 'guides/export-copy-md'
  | 'guides/export-pdf'
  | 'guides/export-docx'
  | 'collections/click-new'
  | 'collections/share-copy-link'
  | 'collections/export-pdf'
  | 'teams/invite-send'
  | 'plans/subscribe'
  | 'billing/discount:modal-show'
  | 'billing/discount:modal-click'
  | 'billing/discount:sidebar-click'
  | 'billing/discount:try-subscribe'
  | 'billing/discount:subscribe'
  | 'apps/click-chrome'
  | 'apps/click-windows';

interface EventData {
  [key: string]: number | string | EventData | number[] | string[] | EventData[];
}

export const sendEvent = (eventName: EventName, data?: EventData) => {
  if (import.meta.env.DEV) {
    console.info('sendEvent', eventName, data);
    return;
  }

  try {
    ym('reachGoal', eventName, {...data});
    window.umami?.track((props) => ({
      ...props,
      name: eventName,
      data,
    }));
  } catch (e) {
    console.log(e);
  }
};
